export const UJET_MENU_KEYS = {
  operationDirectMenu: 'menuHacerOperacion_es',
  legacyMenu: 'gbmhomebroker_chat',
} as const;

export const UJET_URL = 'https://websdk.ujet.co/v2/loader.js';
